import { useEffect, useState } from "react";

const navLinks = [
  { label: "查快照", href: "#search" },
  { label: "核心能力", href: "#features" },
  { label: "版本对比", href: "#compare" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/80 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5" aria-label="吃瓜网页首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-archive-2-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl text-foreground-950">吃瓜网页</span>
            <span className="text-[10px] tracking-wide text-foreground-500">快照 · 缓存 · 存档</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#search"
            className="ml-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即查快照
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-secondary-100 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-secondary-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#search"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              立即查快照
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}